const serviceUrl = `${__configuration.apiUrl}/massia/mouvements-stock`;

export default class StocksCloturesService {
	static $inject = ['$http', 'ModalService', '$translate'];

	constructor($http, ModalService, $translate) {
		this.$http = $http;
		this.$translate = $translate;
		this.ModalService = ModalService;
	}

	async getRegroupementSites(valeur) {
		let url = `${__configuration.apiUrl}/massia/regroupement-sites/typeAhead/${valeur}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getSocietes() {
		let url = `${__configuration.apiUrl}/massia/societes-commerciales`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async clotureJournaliere(idGroupeSite, date) {
		let data = {
			date: date,
			idGroupeSite: idGroupeSite
		};
		let url = `${serviceUrl}/cloture-jour`;
		let res = await this.$http.put(url, data);
		return res.data;
	}

	async clotureMensuelle(grpSiteId, dateStockFinal, idPreCloture) {
		let data = {
			idGroupeSite: grpSiteId,
			dateStockFinal: dateStockFinal,
			idPreCloture: idPreCloture
		};
		let url = `${__configuration.apiUrl}/massia/valorisation-stocks/cloture-mois`;
		let res = await this.$http.put(url, data);
		return res.data;
	}

	async getFormulesExpirees(idGroupeSite, date, showModal) {
		let data = {
			date: JSON.stringify(date),
			idGroupeSite: JSON.stringify(idGroupeSite)
		};
		let url = `${serviceUrl}/formules-expirees`;

		let res = await this.$http.get(url, {
			params: data
		});

		if (showModal && res.data != '') {
			const modalInstance = this.ModalService.confirm({
				modalTitle: this.$translate.instant('STOCKS_CLOTURES.FORMULES_EXPIREES.TITLE'),
				modalMsg:
					this.$translate.instant('STOCKS_CLOTURES.FORMULES_EXPIREES.MESSAGE_START') +
					res.data +
					this.$translate.instant('STOCKS_CLOTURES.FORMULES_EXPIREES.MESSAGE_END'),
				size: 'lg',
				headerClass: 'modal-danger'
			});
			//Si l'utilisateur est ok, alors on continue
			await modalInstance.result;
		}
		return res.data;
	}

	async getDerniereCloture(idGroupeSite) {
		let url = `${serviceUrl}/derniere-cloture-jour/${idGroupeSite}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async estCloture(idGroupeSite, date) {
		let data = {
			date: JSON.stringify(date),
			idGroupeSite: JSON.stringify(idGroupeSite)
		};
		let url = `${serviceUrl}/est-jour-cloture`;
		let res = await this.$http.get(url, {
			params: data
		});
		return res.data;
	}

	async getClotureJour(idGroupeSite, date) {
		let data = {
			date: JSON.stringify(date),
			idGroupeSite: JSON.stringify(idGroupeSite)
		};
		let url = `${serviceUrl}/get-cloture-jour`;
		let res = await this.$http.get(url, {
			params: data
		});
		return res.data;
	}

	async decloturer(idGroupeSite, date) {
		let data = {
			date: date,
			idGroupeSite: idGroupeSite
		};
		let url = `${serviceUrl}/decloture-jour`;
		let res = await this.$http.put(url, data);
		return res.data;
	}

	async getPeriodeEnCoursCloture(idGroupeSite) {
		let url = `${serviceUrl}/get-periode-cloture/${idGroupeSite}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async estClotureMois(idGroupeSite, date) {
		let data = {
			date: JSON.stringify(date),
			idGroupeSite: JSON.stringify(idGroupeSite)
		};
		let url = `${serviceUrl}/est-mois-cloture`;
		let res = await this.$http.get(url, {
			params: data
		});
		return res.data;
	}

	async decloturerMois(idGroupeSite, date) {
		let data = {
			date: date,
			idGroupeSite: idGroupeSite
		};
		let url = `${serviceUrl}/decloture-mois`;
		let res = await this.$http.put(url, data);
		return res.data;
	}

	async getDerniereClotureMois(idGroupeSite) {
		let url = `${serviceUrl}/derniere-cloture-mois/${idGroupeSite}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getClotureMois(idGroupeSite, date) {
		let data = {
			date: JSON.stringify(date),
			idGroupeSite: JSON.stringify(idGroupeSite)
		};
		let url = `${serviceUrl}/get-cloture-mois`;
		let res = await this.$http.get(url, {
			params: data
		});
		return res.data;
	}
}
